export default {
    dependencies: ['$element', 'trackingservice', 'radio'],
    callable(ele, trackingservice, radio) {
        const inputEle = ele.querySelector('input[name=q]');
        const focusEle = ele.querySelector('[data-focus]');

        let prevValue = inputEle.value;

        if (inputEle) {
            inputEle.addEventListener('change', () => {
                if (focusEle) {
                    focusEle.focus();
                }

                if (inputEle.value === prevValue) {
                    return;
                }
                prevValue = inputEle.value;

                trackingservice.trackEventObject({
                    analyticsName: 'navigation.filter-by-keyword.click',
                });
                radio('filter.query-changed').broadcast();
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/queryWidget.js